import React from 'react';
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from '@slorber/react-helmet-async';
import { AuthProvider } from './context/AuthContext';
import { Layout } from './components/layout/Layout';
import { Toaster } from './components/ui/sonner';
import FloatingSupportButton from './components/FloatingSupportButton';

// Pages
import HomePage from './pages/HomePage';
import LoginPage from './pages/LoginPage';
import VerifyPage from './pages/VerifyPage';
import AuthCallback from './pages/AuthCallback';
import ForgotPasswordPage from './pages/ForgotPasswordPage';
import ResetPasswordPage from './pages/ResetPasswordPage';
import ContactPage from './pages/ContactPage';
import CoursesPage from './pages/CoursesPage';
import CourseDetailPage from './pages/CourseDetailPage';
import WorkshopsPage from './pages/WorkshopsPage';
import SculpturesPage from './pages/SculpturesPage';
import VideoPage from './pages/VideoPage';
import MyLibraryPage from './pages/MyLibraryPage';
import AdminPage from './pages/AdminPage';
import AdminSetupPage from './pages/AdminSetupPage';
import AboutPage from './pages/AboutPage';
import MissionPage from './pages/MissionPage';
import PaymentSuccessPage from './pages/PaymentSuccessPage';
import PaymentCancelPage from './pages/PaymentCancelPage';
import ProfilePage from './pages/ProfilePage';
import InstructorPage from './pages/InstructorPage';
import MethodsIndexPage from './pages/MethodsIndexPage';
import MethodPage from './pages/MethodPage';
import PrivacyPage from './pages/PrivacyPage';
import TermsPage from './pages/TermsPage';
import OnlineArtCoursesPage from './pages/OnlineArtCoursesPage';
import PortraitPaintingCoursePage from './pages/PortraitPaintingCoursePage';
import FigureDrawingLessonsPage from './pages/FigureDrawingLessonsPage';
import OilPaintingVideosPage from './pages/OilPaintingVideosPage';
import GlenOrbikCoursePage from './pages/GlenOrbikCoursePage';
import TonyProPaintingPage from './pages/TonyProPaintingPage';
import JeremyLipkingPaintingsPage from './pages/JeremyLipkingPaintingsPage';

function App() {
    return (
        <HelmetProvider>
            <AuthProvider>
                <div className="App">
                    <BrowserRouter>
                        <Layout>
                            <Routes>
                                <Route path="/" element={<HomePage />} />
                                <Route path="/about" element={<AboutPage />} />
                                <Route path="/instructor/:slug" element={<InstructorPage />} />
                                <Route path="/mission" element={<MissionPage />} />
                                <Route path="/methods" element={<MethodsIndexPage />} />
                                <Route path="/methods/:slug" element={<MethodPage />} />
                                <Route path="/login" element={<LoginPage />} />
                                <Route path="/auth/verify" element={<VerifyPage />} />
                                <Route path="/auth/callback" element={<AuthCallback />} />
                                <Route path="/forgot-password" element={<ForgotPasswordPage />} />
                                <Route path="/auth/reset-password" element={<ResetPasswordPage />} />
                                <Route path="/contact" element={<ContactPage />} />
                                <Route path="/courses" element={<CoursesPage />} />
                                <Route path="/courses/:courseId" element={<CourseDetailPage />} />
                                <Route path="/workshops" element={<WorkshopsPage />} />
                                <Route path="/sculptures" element={<SculpturesPage />} />
                                <Route path="/video/:id" element={<VideoPage />} />
                                <Route path="/my-library" element={<MyLibraryPage />} />
                                <Route path="/profile" element={<ProfilePage />} />
                                <Route path="/admin" element={<AdminPage />} />
                                <Route path="/admin-setup" element={<AdminSetupPage />} />
                                <Route path="/payment/success" element={<PaymentSuccessPage />} />
                                <Route path="/payment/cancel" element={<PaymentCancelPage />} />
                                <Route path="/privacy" element={<PrivacyPage />} />
                                <Route path="/terms" element={<TermsPage />} />
                                <Route path="/online-art-courses" element={<OnlineArtCoursesPage />} />
                                <Route path="/portrait-painting-course" element={<PortraitPaintingCoursePage />} />
                                <Route path="/figure-drawing-lessons" element={<FigureDrawingLessonsPage />} />
                                <Route path="/oil-painting-videos" element={<OilPaintingVideosPage />} />
                                <Route path="/glen-orbik-drawing-course" element={<GlenOrbikCoursePage />} />
                                <Route path="/tony-pro-painting-course" element={<TonyProPaintingPage />} />
                                <Route path="/jeremy-lipking-paintings" element={<JeremyLipkingPaintingsPage />} />
                            </Routes>
                        </Layout>
                        <FloatingSupportButton />
                    </BrowserRouter>
                    <Toaster position="bottom-right" />
                </div>
            </AuthProvider>
        </HelmetProvider>
    );
}

export default App;
